export enum AppNameEnum {
  MELAKA = "melaka",
  MELAKA_POS = "melaka-pos",
}

export default AppNameEnum;
